module.exports = __webpack_public_path__ + "static/media/Rectangle 75.50828590.svg";